<template>
  <div>
    <TitlePage title="Modifica Sport Master Config"></TitlePage>

    <v-layout wrap>
      <!-- DATI BASE -->
      <v-flex md6 class="pl-4 pr-4">
        <v-text-field
            label="Sport master (es. calcio, basket)"
            v-model="item.sport_master"
            :error-messages="errors.sport_master"
        />
      </v-flex>

      <v-flex md6 class="pl-4 pr-4 d-flex align-center">
        <v-switch
            v-model="item.active"
            inset
            label="Attivo"
        />
      </v-flex>

      <!-- RUOLI -->
      <v-flex md12 class="pt-4 pl-4 pr-4">
        <h4 class="mb-2">Ruoli</h4>
        <p class="text--secondary text-caption mb-3">
          Definisci i ruoli disponibili per questo sport.
        </p>

        <v-card outlined>
          <v-card-text>
            <v-btn small color="secondary" @click="addRole">
              <v-icon left small>mdi-plus</v-icon>
              Aggiungi ruolo
            </v-btn>

            <v-simple-table class="mt-3">
              <thead>
              <tr>
                <th style="width: 15%">Key</th>
                <th style="width: 25%">Label</th>
                <th>Descrizione</th>
                <th style="width: 40px"></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(role, index) in item.roles"
                  :key="'role-'+index"
              >
                <td>
                  <v-text-field
                      v-model="role.key"
                      dense
                      hide-details
                      placeholder="es. P"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="role.label"
                      dense
                      hide-details
                      placeholder="Portiere"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="role.description"
                      dense
                      hide-details
                      placeholder="Descrizione (opzionale)"
                  />
                </td>
                <td class="text-center">
                  <v-icon
                      small
                      color="red"
                      class="mt-1"
                      @click="removeRole(index)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
              <tr v-if="!item.roles.length">
                <td colspan="4" class="text-center grey--text text--darken-1 text-caption py-3">
                  Nessun ruolo configurato.
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- SKILL -->
      <v-flex md12 class="pt-8 pl-4 pr-4">
        <h4 class="mb-2">Skill</h4>
        <p class="text--secondary text-caption mb-3">
          Definisci le skill che l'utente potrà valutare.
        </p>

        <v-card outlined>
          <v-card-text>
            <v-btn small color="secondary" @click="addSkill">
              <v-icon left small>mdi-plus</v-icon>
              Aggiungi skill
            </v-btn>

            <v-simple-table class="mt-3">
              <thead>
              <tr>
                <th style="width: 10%">Key</th>
                <th style="width: 18%">Label</th>
                <th>Descrizione</th>
                <th style="width: 12%">Tipo</th>
                <th style="width: 7%">Min</th>
                <th style="width: 7%">Max</th>
                <th style="width: 7%">Step</th>
                <th style="width: 7%">Peso</th>
                <th style="width: 10%">Attiva</th>
                <th style="width: 40px"></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(skill, index) in item.skills"
                  :key="'skill-'+index"
              >
                <td>
                  <v-text-field
                      v-model="skill.key"
                      dense
                      hide-details
                      placeholder="speed"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="skill.label"
                      dense
                      hide-details
                      placeholder="Velocità"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="skill.description"
                      dense
                      hide-details
                      placeholder="Descrizione"
                  />
                </td>
                <td>
                  <v-select
                      v-model="skill.type"
                      :items="skillTypes"
                      dense
                      hide-details
                  />
                </td>
                <td>
                  <v-text-field
                      v-model.number="skill.min"
                      dense
                      hide-details
                      type="number"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model.number="skill.max"
                      dense
                      hide-details
                      type="number"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model.number="skill.step"
                      dense
                      hide-details
                      type="number"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model.number="skill.weight"
                      dense
                      hide-details
                      type="number"
                  />
                </td>
                <td class="text-center">
                  <v-switch
                      v-model="skill.active"
                      hide-details
                      inset
                      dense
                  />
                </td>
                <td class="text-center">
                  <v-icon
                      small
                      color="red"
                      class="mt-1"
                      @click="removeSkill(index)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
              <tr v-if="!item.skills.length">
                <td colspan="10" class="text-center grey--text text--darken-1 text-caption py-3">
                  Nessuna skill configurata.
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- STATS -->
      <v-flex md12 class="pt-8 pl-4 pr-4">
        <h4 class="mb-2">Statistiche</h4>
        <p class="text--secondary text-caption mb-3">
          Definisci quali statistiche verranno salvate post partita.
        </p>

        <v-card outlined>
          <v-card-text>
            <v-btn small color="secondary" @click="addStat">
              <v-icon left small>mdi-plus</v-icon>
              Aggiungi statistica
            </v-btn>

            <v-simple-table class="mt-3">
              <thead>
              <tr>
                <th style="width: 10%">Key</th>
                <th style="width: 18%">Label</th>
                <th>Descrizione</th>
                <th style="width: 10%">Tipo</th>
                <th style="width: 12%">Aggregazione</th>
                <th style="width: 10%">In profilo</th>
                <th style="width: 10%">Attiva</th>
                <th style="width: 40px"></th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(stat, index) in item.stats"
                  :key="'stat-'+index"
              >
                <td>
                  <v-text-field
                      v-model="stat.key"
                      dense
                      hide-details
                      placeholder="goals"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="stat.label"
                      dense
                      hide-details
                      placeholder="Gol"
                  />
                </td>
                <td>
                  <v-text-field
                      v-model="stat.description"
                      dense
                      hide-details
                      placeholder="Descrizione"
                  />
                </td>
                <td>
                  <v-select
                      v-model="stat.type"
                      :items="statTypes"
                      dense
                      hide-details
                  />
                </td>
                <td>
                  <v-select
                      v-model="stat.aggregate"
                      :items="aggregateTypes"
                      dense
                      hide-details
                  />
                </td>
                <td class="text-center">
                  <v-switch
                      v-model="stat.show_in_profile"
                      hide-details
                      inset
                      dense
                  />
                </td>
                <td class="text-center">
                  <v-switch
                      v-model="stat.active"
                      hide-details
                      inset
                      dense
                  />
                </td>
                <td class="text-center">
                  <v-icon
                      small
                      color="red"
                      class="mt-1"
                      @click="removeStat(index)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
              <tr v-if="!item.stats.length">
                <td colspan="8" class="text-center grey--text text--darken-1 text-caption py-3">
                  Nessuna statistica configurata.
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- BOTTONI -->
      <v-flex md12 class="pt-10 d-flex buttons-group-mobile">
        <v-btn elevation="2" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          Indietro
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update">
          Salva
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TitlePage from '@/components/utils/TitlePage'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'SportMasterConfigEdit',
  components: { TitlePage },
  data () {
    return {
      item: {
        sport_master: '',
        active: true,
        roles: [],
        skills: [],
        stats: []
      },
      errors: {
        sport_master: ''
      },
      skillTypes: ['number', 'select', 'boolean'],
      statTypes: ['number', 'boolean'],
      aggregateTypes: ['sum', 'avg', 'count', 'max', 'min']
    }
  },
  async created () {
    this.setLoading(true)
    const fetchItem = await this.editItem({ id: this.$route.params.id })

    if (fetchItem && fetchItem.success) {
      // clone per evitare side effect
      this.item = {
        sport_master: fetchItem.result.sport_master,
        active: typeof fetchItem.result.active === 'boolean' ? fetchItem.result.active : true,
        roles: fetchItem.result.roles || [],
        skills: fetchItem.result.skills || [],
        stats: fetchItem.result.stats || []
      }
    }
    this.setLoading(false)
  },
  methods: {
    ...mapMutations({
      setLoading: 'settings/setLoading',
      setNotification: 'settings/setNotification'
    }),
    ...mapActions({
      editItem: 'sportMasterConfig/edit',
      updateItem: 'sportMasterConfig/update'
    }),

    addRole () {
      this.item.roles.push({
        key: '',
        label: '',
        description: ''
      })
    },
    removeRole (index) {
      this.item.roles.splice(index, 1)
    },

    addSkill () {
      this.item.skills.push({
        key: '',
        label: '',
        description: '',
        type: 'number',
        min: 1,
        max: 10,
        step: 1,
        weight: 1,
        active: true
      })
    },
    removeSkill (index) {
      this.item.skills.splice(index, 1)
    },

    addStat () {
      this.item.stats.push({
        key: '',
        label: '',
        description: '',
        type: 'number',
        aggregate: 'sum',
        show_in_profile: true,
        active: true
      })
    },
    removeStat (index) {
      this.item.stats.splice(index, 1)
    },

    validate () {
      this.errors.sport_master = ''

      if (!this.item.sport_master) {
        this.errors.sport_master = 'Campo obbligatorio'
        return false
      }
      return true
    },

    async update () {
      if (!this.validate()) return

      this.setLoading(true)
      const result = await this.updateItem({
        id: this.$route.params.id,
        item: this.item
      })
      this.setLoading(false)

      if (result.success) {
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: 'Configurazione aggiornata con successo'
        })
      } else {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })
      }
    }
  }
}
</script>
